import { fakeIntl } from '../../util/test-data';
import StripePaymentForm from './StripePaymentForm';

const noop = () => null;

export const Empty = {
  component: StripePaymentForm,
  props: {
    formId: 'StripePaymentFormExample',
    authorDisplayName: 'Janne K',
    paymentInfo: 'You might or might not be charged yet',
    onChange: values => {
      console.log('form onChange:', values);
    },
    onSubmit: values => {
      console.log('form onSubmit:', values);
    },
    intl: fakeIntl,
    onCreateStripePaymentToken: noop,
    onStripeInitialized: noop,
    stripePaymentTokenInProgress: false,
    stripePaymentTokenError: null,
  },
  group: 'forms',
};

// The checkout of a custom offer: the card address is pre-filled from the
// customer's billing profile, so it shows as one line with an edit button.
export const PrefilledCardAddress = {
  component: StripePaymentForm,
  props: {
    formId: 'StripePaymentFormPrefilledExample',
    authorDisplayName: 'Janne K',
    paymentInfo: 'Palvelun tilaaminen on helppoa ja turvallista.',
    showInitialMessageInput: true,
    description: '',
    initialValues: {
      name: 'Joni Ostaja',
      addressLine1: 'Suokalliontie 1 A 1',
      postal: '01740',
      city: 'Vantaa',
      country: 'FI',
    },
    onSubmit: values => {
      console.log('form onSubmit:', values);
    },
    onCancel: noop,
    onStripeInitialized: noop,
  },
  group: 'forms',
};
